import { TableRowDisplayEvent } from "@mcleod/components";
import { AutogenLayoutDriverRatingList } from "./autogen/AutogenLayoutDriverRatingList";

export class DriverRatingList extends AutogenLayoutDriverRatingList {

   onLoad(): void | Promise<void> {
       this.sourceDriverRating.orderBy = [{field: "id", sort: "asc"}];
   }
}
